import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";
import { Button } from "./ui/button";
import { reloadApp } from "../lib/firestore-recovery";

function useOnline(): boolean {
  const [online, setOnline] = useState(() => navigator.onLine !== false);
  useEffect(() => {
    const update = () => setOnline(navigator.onLine !== false);
    window.addEventListener("online", update);
    window.addEventListener("offline", update);
    return () => {
      window.removeEventListener("online", update);
      window.removeEventListener("offline", update);
    };
  }, []);
  return online;
}

/**
 * Shown when a screen takes too long. The button restarts the app's web
 * content, which is what closing and reopening the app did for users.
 */
export function SlowLoadingNotice({ screen }: { screen: string }) {
  const online = useOnline();
  const [waitingForUpload, setWaitingForUpload] = useState(false);
  return (
    <div className="max-w-xs space-y-3 text-center animate-in fade-in slide-in-from-bottom-2">
      <p className="text-sm text-muted-foreground">
        {online
          ? "Učitavanje traje dulje nego inače. Provjerite internetsku vezu."
          : "Nema internetske veze. Sadržaj će se učitati čim se veza vrati."}
      </p>
      {waitingForUpload && (
        <p className="text-sm text-muted-foreground">
          Aplikacija će se osvježiti čim se prijenos videa završi.
        </p>
      )}
      <Button
        variant="outline"
        disabled={waitingForUpload}
        onClick={() => setWaitingForUpload(!reloadApp(`retry button: ${screen}`))}
      >
        <RefreshCw className="mr-2 h-4 w-4" />
        Pokušaj ponovno
      </Button>
    </div>
  );
}
